import { render, staticRenderFns } from "./search-recipes-landing.vue?vue&type=template&id=6670ef1e&scoped=true&"
import script from "./search-recipes-landing.vue?vue&type=script&lang=js&"
export * from "./search-recipes-landing.vue?vue&type=script&lang=js&"
import style0 from "./search-recipes-landing.vue?vue&type=style&index=0&id=6670ef1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6670ef1e",
  null
  
)

export default component.exports